import React from 'react';
import { makeStyles } from 'utils/makeStylesAdapter';
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
} from '@mui/material';
import { currencyFormat } from 'utils/currency';

const useStyles = makeStyles(() => ({
  table: {
    width: '100%',
    minWidth: 700,
  },
  container: {
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
  },
}));

const monetaryValue = value => currencyFormat(Number(value || 0) / 100);
const projectValue = value => currencyFormat(Number(value || 0));

const TableProjectBalances = props => {
  const { tableProjectBalancesData } = props;

  const classes = useStyles();

  return (
    <>
      <Box style={{ marginBottom: 30 }} width="100%">
        <Box my={1}>
          {tableProjectBalancesData && (
            <TableContainer component={Paper} className={classes.container}>
              <Table className={classes.table} size="small" aria-label="a dense table" stickyHeader>
                <TableBody>
                  {tableProjectBalancesData?.map(item => {
                    const hasEstimatedValue = Number(item.projectTotalValue || 0) > 0;
                    const hasEstimatedHours = Number(item.projectTotalHours || 0) > 0;

                    return (
                      <React.Fragment key={item.projectId}>
                        <TableRow>
                          <TableCell style={{ fontWeight: 'bold' }} colSpan={3}>
                            <Typography variant="body2">{item.projectName}</Typography>
                          </TableCell>
                        </TableRow>

                        {hasEstimatedValue ? (
                          <>
                            <TableRow>
                              <TableCell align="center">Valor Estimado</TableCell>
                              <TableCell align="center">
                                Bens, Recurso e Montante Destinados
                              </TableCell>
                              <TableCell align="center">Quantia Efetivamente Destinada</TableCell>
                            </TableRow>
                            <TableRow hover>
                              <TableCell align="center">
                                <Typography variant="body2">
                                  {projectValue(item.projectTotalValue)}
                                </Typography>
                              </TableCell>
                              <TableCell align="center">
                                <Typography variant="body2">
                                  {monetaryValue(item.pecuniaryDestinedValue)}
                                </Typography>
                              </TableCell>
                              <TableCell align="center">
                                <Typography variant="body2">
                                  {monetaryValue(item.pecuniaryFulfilledValue)}
                                </Typography>
                              </TableCell>
                            </TableRow>
                          </>
                        ) : null}

                        {hasEstimatedHours ? (
                          <>
                            <TableRow>
                              <TableCell align="center">Hora Total</TableCell>
                              <TableCell align="center">Hora Destinada</TableCell>
                              <TableCell align="center">Hora Efetivamente Cumprida</TableCell>
                            </TableRow>
                            <TableRow hover>
                              <TableCell align="center">
                                <Typography variant="body2">{item.projectTotalHours}</Typography>
                              </TableCell>
                              <TableCell align="center">
                                <Typography variant="body2">{item.serviceDestinedValue}</Typography>
                              </TableCell>
                              <TableCell align="center">
                                <Typography variant="body2">{item.serviceFulfilledValue}</Typography>
                              </TableCell>
                            </TableRow>
                          </>
                        ) : null}
                      </React.Fragment>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </Box>
      </Box>
    </>
  );
};

export default TableProjectBalances;
